// extracted by mini-css-extract-plugin
module.exports = {"image":"Image_image__102xB","skeleton":"Image_skeleton__pQ9Kh","skeleton-loading":"Image_skeleton-loading__3Dd7C","fallback":"Image_fallback__elXdz"};